import React, { useEffect, useState } from "react";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { getSiteOptions } from "./sitesApi";

// Site dropdown for Employee Onboarding and Employee Edit: active sites as
// "Erode Unit 1 (SITE-01)". Optional. value = site id (or null);
// currentSite = the employee's saved site { id, name, code }, kept in the
// list even if it was deactivated since.

export const siteOptionLabel = (site) => (site ? `${site.name} (${site.code})` : "");

// Options may come as a list or wrapped ({ results } / { sites }), with
// name/code or site_name/site_code.
const toSites = (data) => {
  const list = Array.isArray(data) ? data : data?.results || data?.sites || data?.data || [];
  return (Array.isArray(list) ? list : [])
    .map((site) => ({ ...site, id: site.id ?? site.site_id, name: site.name ?? site.site_name ?? "", code: site.code ?? site.site_code ?? "" }))
    .filter((site) => site.id != null);
};

export const SiteSelect = ({ domain, value, onChange, currentSite, placeholder = "Select the site", disabled }) => {
  const [sites, setSites] = useState([]);
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!domain) return undefined;
    const controller = new AbortController();
    setState("loading");
    getSiteOptions({ domain, signal: controller.signal })
      .then((data) => {
        setSites(toSites(data));
        setState("ready");
      })
      .catch((err) => {
        if (err?.name !== "AbortError") setState("failed");
      });
    return () => controller.abort();
  }, [domain]);

  const rows = currentSite && !sites.some((site) => String(site.id) === String(currentSite.id)) ? [...sites, currentSite] : sites;
  const options = rows.map((site) => ({ ...site, label: siteOptionLabel(site) }));
  const selected = options.find((option) => String(option.id) === String(value));
  const hint =
    state === "loading"
      ? "Loading sites…"
      : state === "failed"
        ? "Couldn't load sites"
        : !options.length
          ? "No sites — add them in Administration › Sites"
          : placeholder;

  return (
    <CustomAutoComplete
      dataList={options}
      selectedValue={selected || null}
      updateDataFunction={(event, option) => onChange(option ? option.id : null, option || null)}
      placeHolder={hint}
      disableAction={disabled}
    />
  );
};

export default SiteSelect;
